module.exports = __webpack_public_path__ + "./docs/img/icon-class.06983707fd66d39a4f8f31bb24851229.svg";